import { MbAnagraficaProductionDepartment } from "../mb_anagrafiche/mb_tables/mb_anagrafica_production_department";
import { MbAnagraficaUm } from "../mb_anagrafiche/mb_tables/mb_anagrafica_um";
import { MbMessage } from "../mb_components/mb_message";

const MbValidatorProductionDepartment = ({callbackFromValidator}) => {

    return (
        <>
            <MbMessage title="Reparto di produzione" helper="Selezionare un reparto di produzione" open isFullscreen>
                <div style={{paddingLeft: "30px", paddingRight: "30px"}}>
                    <MbAnagraficaProductionDepartment isValidator callbackFromValidator={(item) => {
                        callbackFromValidator(item);
                    }}/>
                </div>
            </MbMessage>
        </>
    );
};

export {
    MbValidatorProductionDepartment
}